<dx-page [options]="pageOptions">
  <ng-container *dxPageHeader>
    <dx-page-header [options]="headerOptions"></dx-page-header>
  </ng-container>
  <ng-container *dxPageContent>
    <dx-login-form (submitClick)="onSubmitClick($event)"
                   (registerClick)="onRegisterClick()"
                   (forgotPasswordClick)="onForgotPasswordClick()">
    </dx-login-form>
  </ng-container>
  <ng-container *dxPageFooter>
    <pit-page-footer></pit-page-footer>
  </ng-container>
</dx-page>
